import React, { useState, useEffect, useContext } from 'react';
import { Trans } from '@lingui/react';
import { fetchBriefestEventParticipationByContactId } from '../../Service/restapi/eventService';

export const ChatMessageEventRole = ({ profileContactId, emailToId, emailFromId, style }) => {
  const [eventRole, setEventRole] = useState(undefined);

  useEffect(() => {
    if (emailToId) {
      const customerId = profileContactId === emailToId ? emailFromId : emailToId;
      fetchEventParticipation(customerId);
    } else {
      new Error('ToId of Email is null');
    }
  }, [profileContactId, emailToId, emailFromId]);

  function fetchEventParticipation(customerId) {
    // ask event service for participating in next or last event
    fetchBriefestEventParticipationByContactId(customerId, true).then((resp) => {
      if (resp.status === 200) {
        resp.json().then((participations) => {
          if (participations[0]) {
            setEventRole(participations[0].eventRole);
          }
        });
      }
    });
  }

  if (!eventRole) return null;

  const styles = {
    eventRole: {
      color: '#969696',
      fontSize: 11,
      padding: 0,
    },
  };

  return (
    <div style={style}>
      {eventRole !== undefined ? (
        <div style={styles.eventRole}>
          <Trans id={`eventrole.${eventRole.toLowerCase()}`} />
        </div>
      ) : (
        ''
      )}
    </div>
  );
};
